<template>
  <div>
    <div>
      <label class="text-base font-bold text-white/75"
        >Property Status</label
      >
    </div>
    <div class="">
      <label class="form-checkbox group">
        <input
          type="checkbox"
          name="status[]"
          value="Active"
          class="checkbox-input"
          v-model="status.active"
        />
        <span class="checkbox-label">Active</span>
      </label>
      <label class="form-checkbox group">
        <input
          type="checkbox"
          name="status[]"
          value="Contingent"
          class="checkbox-input"
          v-model="status.contingent"
        />
        <span class="checkbox-label">Under Contract</span>
      </label>
      <label class="form-checkbox group">
        <input
          type="checkbox"
          name="status[]"
          value="Sold/Closed"
          class="checkbox-input"
          v-model="status.sold"
        />
        <span class="checkbox-label">Sold</span>
      </label>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    fieldValue: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      status: {
        active: true,
        contingent: true,
        sold: false,
      },
      value: "",
    };
  },

  watch: {
    status: {
      deep: true,
      handler(val) {
        this.value = [];

        if (val.active == true) {
          this.value.push("Active");
        }
        if (val.sold == true) {
          this.value.push("Sold/Closed");
        }
        if (val.contingent == true) {
          this.value.push("Contingent");
        }

        this.$emit("updated", {
          property: "status",
          value: this.value.join('|'),
        });
      },
    },
  },

  mounted() {
    this.status.active = this.fieldValue.includes("Active")
    this.status.sold = this.fieldValue.includes("Sold/Closed")
    this.status.contingent = this.fieldValue.includes("Contingent")
    this.value = this.fieldValue
  },
};
</script>
